import React, { createContext, useReducer } from "react";
import aliceGPTReducer from "./AliceGPTReducer";
import { OPENAI_MODEL } from "../../Constants/OpenAI";

const initialState = {
    step: 0,
    form: {
        projectName: "",
        domain: "",
        description: "",
        model: OPENAI_MODEL
    },
    subscription: {},
    isLoadingEntities: true,
    formUpdated: false,
    initialAttributesLoaded: true,
    showAdvancedConfigurations: false,
    isPageConfigurationLoading: true,
    shouldLoadPageConfiguration: true,
    shouldLoadPortals: true,
    shouldLoadFormula: true,
    entities: [],
    relations: [],
    selectedEntity: [],
    selectedRelation: [],
    namesOfSelectedEntities: [],
    previousNamesOfSelectedEntities: [],
    error: "",
    swapErrors: {}, // Add swap errors state to track errors for each relation
    portals: [], // Add portals to initial state
    roles: [],
    selectedRoles: [],
    shouldLoadRoles: true,
    rolesLoading: false,
    showRoleDialog: false,
    calculatedFields: [], // Add calculatedFields to initial state
    isLoadingCalculatedFields: false, // Add loading state for calculated fields
    
    // Formula recommendation states
    formulaRecommendations: {},
    formulaRecommendationsLoading: false,
    formulaSelectedEntityIndex: 0,
    formulaSelectedRecommendationIndices: [],
    formulaEditDialogVisible: false,
    formulaEditingAttribute: null,
    formulaEditingIndex: null,
    // Add portal settings state
    portalSettings: {
        menuOrientation: 'Top',
        logoFile: null,
        logoPreview: ''
    },
    // File state
    selectedFile: null,
    fileName: "",
    fileError: "",
    fileProcessedForDescription: false
}

const AliceGPTContext = createContext(initialState);

export const AliceGPTContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(aliceGPTReducer, initialState);

    return (
        <AliceGPTContext.Provider value={[state, dispatch]}>
            {children}
        </AliceGPTContext.Provider>
    )
}

export default AliceGPTContext;